import React from 'react';
import LockIcon from '@assets/icons/lock.svg';
import { BaseButton } from '@components';
import { BodyMdMd, HeadingSm } from '@constants/text.ts';
import { useLingui } from '@lingui/react/macro';
import {
    LockedButtons,
    LockedContentWrapper,
    LockedInfo,
} from '@routes/sidebar/learning/ui/learning-tab/locked-content/styled.tsx';
import { scrollToElementByRefOrId } from '@utils/scroll.ts';

interface Props {
    elementIdToScrollTo: string;
}

export const LockedContent: React.FC<Props> = ({ elementIdToScrollTo }) => {
    const { t } = useLingui();

    return (
        <LockedContentWrapper>
            <LockedInfo>
                <div>
                    <div>
                        <LockIcon />
                    </div>
                </div>
                <span>
                    <HeadingSm>{t`This content is locked`}</HeadingSm>
                    <BodyMdMd>{t`Complete all Mandatory Learning to unlock this section.`}</BodyMdMd>
                </span>
                <LockedButtons>
                    <BaseButton
                        onClick={() => scrollToElementByRefOrId(null, elementIdToScrollTo)}
                    >{t`View mandatory learning`}</BaseButton>
                </LockedButtons>
            </LockedInfo>
        </LockedContentWrapper>
    );
};
